const MB = 720;
const PC = 2240;

export { MB, PC };
